module.exports = __webpack_public_path__ + "img/vr2_detail_2.edb9e62a.jpg";